import React from 'react'
import { Rating } from '@softura/fluentuipackage'
import './Rating.scss'

interface IProps {
  className?: string,
  max?: number,
  defaultRating?: number,
  onChange?:any;
  readOnly?:any;
  allowZeroStars ?:any;
  rating?:any,
  inputRef?:any,
  componentRef?:any
}
const RatingContainer = ({
  className,
  max,
  defaultRating,
  onChange,
  readOnly,
  allowZeroStars,
  rating,
  inputRef,
  componentRef
}:IProps) => {
  return (
    <Rating
      className = {`rating-star ${className}`}
      defaultRating = {defaultRating}
      max = {max}
      onChange={onChange}
      readOnly={readOnly}
      allowZeroStars ={allowZeroStars }
      rating={rating}
      inputRef={inputRef}
      componentRef={componentRef}
     data-attribute="index_Default_Rating" />
  )
}

export default RatingContainer
